import React, {useContext, useState} from 'react'
import { Row, Col, Input, Select, DatePicker, TimePicker, Radio } from "antd";
import { AppContext } from '../../util/context';
import { conditionDetails, country, externalCustomers, locations, newDepartments, otherCountries } from '../../util/details'
import DatePickerMobile from './DatePickerMobile';
import TimePickerMobile from './TimePickerMobile';
import ObservationDescriptionInput from './ObservationDescriptionInput';
import { getSorted } from '../../util/details';



const {Option} = Select;

export const GeneralInformation = ({setGeneralValidations, generalValidations, formState, setFormState}) => {
    const {
        userData,
        StyledDiv
    } = useContext(AppContext)

    const [showDatePicker, setShowDatePicker] = useState(false)
    const [showTimePicker, setShowTimePicker] = useState(false)


    return (
        <>   
              
            <DatePickerMobile 
                showDatePicker={showDatePicker} 
                setShowDatePicker={setShowDatePicker}
                StyledDiv={StyledDiv}
                formState={formState}
                setFormState={setFormState}
                setGeneralValidations={setGeneralValidations}

            />  

            <TimePickerMobile
                showTimePicker={showTimePicker} 
                setShowTimePicker={setShowTimePicker}
                StyledDiv={StyledDiv}
                formState={formState}
                setFormState={setFormState}
                setGeneralValidations={setGeneralValidations}

            /> 
            <Row
                gutter={[0, 15]}
                className='InputContainer'
            >
                <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px",
                    }}
                >
                    <label><StyledDiv className="newInputTextLabel"><span style={{color: "red"}}>*</span> Employee {generalValidations.employee !== "" && <StyledDiv style={{color:"red", fontSize: "10px"}}>{generalValidations.employee}</StyledDiv>}</StyledDiv></label>
                    <Radio.Group 
                        value={formState.employee}
                        onChange={(e) => {
                            setFormState(prevState => ({ ...prevState, employee: e.target.value, businessUnit: e.target.value === 'identified' ? '' : 'Anonymous' }));
                            if(generalValidations.employee !== "")
                                setGeneralValidations(prevState => ({ ...prevState, employee: "" }));
                        }}
                        style={{
                            marginTop: "10px"
                        }}
                    >
                        
                        <StyledDiv>
                            <Radio value="anonymous" className="newInputText">Anonymous</Radio>
                            <Radio value="identified" className="newInputText">Identified</Radio>
                        </StyledDiv>
                    </Radio.Group>
                    
                    
                </Col>

                {formState.employee === 'identified' && <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px"
                    }}
                >
                    <label><StyledDiv className="newInputTextLabel"><span style={{color: "red"}}>*</span> Employee Name</StyledDiv></label>
                    <Input placeholder="Enter employee name"
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}} 
                        onChange={(e) => setFormState(prevState => ({ ...prevState, employeeName: e.target.value }))}
                        value={userData.given_name + " " + userData.family_name}
                        className="newInputText"
                    />
                </Col>}

                <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px"
                    }}
                >
                    <label><StyledDiv className="newInputTextLabel"><span style={{color: "red"}}>*</span> Business Unit</StyledDiv></label>
                    <div className="generalInfoContainer">
                        <Select style={{width: "100%", marginTop: "8px", height: "40px"}}
                            onChange={(value) => {
                                setFormState(prevState => ({ ...prevState, businessUnit: value }));
                                if(generalValidations.businessUnit !== "")
                                    setGeneralValidations(prevState => ({ ...prevState, businessUnit: "" }));
                            }}
                            value={formState.businessUnit}
                            disabled={false}
                            className={generalValidations.businessUnit !== "" ? "newInputText validationInputText" : "newInputText"}
                        >   
                            {getSorted(newDepartments).map((department, index) => (
                                <Option key={index} value={department.value} className="newInputText">{department.name}</Option>
                            ))}
                        </Select>
                        {generalValidations.businessUnit && 
                            <span className="validationMessage">{generalValidations.businessUnit}</span>
                        }
                    </div>
                </Col>

                {formState.employee === 'identified' && <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 0}}
                    xs={{span: 0}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px"
                    }}
                ></Col>}
                
            </Row>    

            <Row gutter={[0, 15]} className='InputContainer'>
                <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px"
                    }}
                >

                    <label>
                        <StyledDiv className="newInputTextLabel">
                            <span style={{color: "red"}}>*</span> Date Observed (YYYY-MM-DD)
                            <div className="generalInfoContainer">
                                <DatePicker 
                                    style={{width: "100%", marginTop: "8px", height: "40px"}}
                                    onChange={(date, dateString) => {
                                        setFormState(prevState => ({ ...prevState, dateObserved: dateString, defaultDate: date })); 
                                        if(generalValidations.dateObserved !== "")
                                            setGeneralValidations(prevState => ({ ...prevState, dateObserved: "" }));
                                    }}
                                    format="YYYY-MM-DD"
                                    value={formState.defaultDate}
                                    className={generalValidations.dateObserved !== "" ? "datePickerDesktop newInputText validationInputText" : "datePickerDesktop newInputText"}
                                />
                                <input
                                    className={generalValidations.dateObserved !== "" ? "datepickerMobileInput newInputText validationInputText" : "datepickerMobileInput newInputText"}
                                    value={formState.dateObserved}
                                    onClick={() => setShowDatePicker(true)}
                                    readOnly={true}
                                />
                                {/* <CalendarOutlined 
                                    className="datepickerMobileIcon"
                                    onClick={() => setShowDatePicker(true)}
                                /> */}
                                {generalValidations.dateObserved && 
                                    <span className="validationMessageDatePicker">{generalValidations.dateObserved}</span>
                                }
                            </div>
                        </StyledDiv>
                    </label>
                </Col>

                <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px"
                    }}
                >
                    <label>
                        <StyledDiv className="newInputTextLabel">
                            <span style={{color: "red"}}>*</span> Time Observed (H-M-S)
                            <div className="generalInfoContainer">
                                <TimePicker 
                                    style={{width: "100%", marginTop: "8px", height: "40px"}}
                                    onChange={(time, timeString) => {
                                        setFormState(prevState => ({ ...prevState, timeObserved: timeString, defaultTime: time })); 
                                        if(generalValidations.timeObserved !== "")
                                            setGeneralValidations(prevState => ({ ...prevState, timeObserved: "" }));
                                    }}
                                    use12Hours format="h:mm:ss A"
                                    value={formState.defaultTime}
                                    className={generalValidations.timeObserved !== "" ? "datePickerDesktop newInputText validationInputText" : "datePickerDesktop newInputText"}
                                />

                                <input
                                    className={generalValidations.timeObserved !== "" ? "datepickerMobileInput newInputText validationInputText" : "datepickerMobileInput newInputText"}
                                    value={formState.timeObserved}
                                    onClick={() => setShowTimePicker(true)}
                                    readOnly={true}
                                />
                                {/* <ClockCircleOutlined
                                    className="datepickerMobileIcon"
                                    onClick={() => setShowTimePicker(true)}
                                /> */}
                                {generalValidations.timeObserved && 
                                    <span className="validationMessage">{generalValidations.timeObserved}</span>
                                }
                            </div>
                        </StyledDiv>
                    </label>
                </Col>

            </Row>   

            <Row gutter={[0, 15]} className='InputContainer'>

                <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px"
                    }}
                >

                    <label>     
                        <StyledDiv className="newInputTextLabel">
                            <span style={{color: "red"}}>*</span> Country
                            <div className="generalInfoContainer">
                                <Select placeholder="Select country" style={{width: "100%", marginTop: "8px", height: "40px"}}
                                    onChange={(value) => {
                                        setFormState(prevState => ({ ...prevState, country: value }))
                                        if(generalValidations.country !== "")
                                            setGeneralValidations(prevState => ({ ...prevState, country: "" }));
                                    }}
                                    value={formState.country}
                                    className={generalValidations.country !== "" ? "newInputText validationInputText" : "newInputText"}
                                >
                                    {getSorted(country).map((location, index) => (
                                        <Option key={index} value={location.value} className="newInputText">{location.name}</Option>
                                    ))}
                                </Select>
                                {generalValidations.country && 
                                    <span className="validationMessage">{generalValidations.country}</span>
                                }
                            </div>
                        </StyledDiv>
                    </label>
                </Col>

                {formState.country === "Other" && <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px"
                    }}
                >

                    <label>     
                        <StyledDiv className="newInputTextLabel">
                            <span style={{color: "red"}}>*</span> State Other Country
                            <div className="generalInfoContainer">
                                <Select placeholder="Select other country" style={{width: "100%", marginTop: "8px", height: "40px"}}
                                    onChange={(value) => {
                                        setFormState(prevState => ({ ...prevState, otherCountry: value }))
                                        if(generalValidations.otherCountry !== "")
                                            setGeneralValidations(prevState => ({ ...prevState, otherCountry: "" }));
                                    }}
                                    showSearch
                                    value={formState.otherCountry}
                                    className={generalValidations.otherCountry !== "" ? "newInputText validationInputText" : "newInputText"}
                                >
                                    {getSorted(otherCountries).map((location, index) => (
                                        <Option key={index} value={location.value} className="newInputText">{location.name}</Option>
                                    ))}
                                </Select>
                                {generalValidations.otherCountry && 
                                    <span className="validationMessage">{generalValidations.otherCountry}</span>
                                }
                            </div>
                        </StyledDiv>
                    </label>
                </Col>}

                <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px",
                    }}
                >
                    <label><StyledDiv className="newInputTextLabel"><span style={{color: "red"}}>*</span> Location {generalValidations.locationType !== "" && <StyledDiv style={{color:"red", fontSize: "10px"}}>{generalValidations.locationType}</StyledDiv>}</StyledDiv></label>
                    <Radio.Group 
                        value={formState.locationType}
                        onChange={(e) => {
                            setFormState(prevState => ({ ...prevState, locationType: e.target.value }));
                            if(generalValidations.locationType !== "")
                                setGeneralValidations(prevState => ({ ...prevState, locationType: "" }));
                        }}
                        style={{
                            marginTop: "10px"
                        }}
                    >
                        
                        <StyledDiv>
                            <Radio value="Internal" className="newInputText">Internal</Radio>
                            <Radio value="External" className="newInputText">External</Radio>
                        </StyledDiv>
                    </Radio.Group>
                    
                    
                </Col>

                {formState.locationType === "Internal" && <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px"
                    }}
                >

                    <label>     
                        <StyledDiv className="newInputTextLabel">
                            <span style={{color: "red"}}>*</span> Locations owned and operated by TES
                            <div className="generalInfoContainer">
                                <Select placeholder="Select location" style={{width: "100%", marginTop: "8px", height: "40px"}}
                                    onChange={(value) => {
                                        setFormState(prevState => ({ ...prevState, location: value }))
                                        if(generalValidations.location !== "")
                                            setGeneralValidations(prevState => ({ ...prevState, location: "" }));
                                    }}
                                    showSearch
                                    value={formState.location}
                                    className={generalValidations.location !== "" ? "newInputText validationInputText" : "newInputText"}
                                >
                                    {getSorted(locations).map((location, index) => (
                                        <Option key={index} value={location.value} className="newInputText">{location.name}</Option>
                                    ))}
                                </Select>
                                {generalValidations.location && 
                                    <span className="validationMessage">{generalValidations.location}</span>
                                }
                            </div>
                        </StyledDiv>
                    </label>
                </Col>}

                {formState.locationType === "External" && <>
                    <Col
                        xl={{span: 12}}
                        lg={{span: 12}}
                        md={{span: 12}}
                        sm={{span: 24}}
                        xs={{span: 24}}
                        style={{
                            paddingRight: "10px",
                            marginBottom: "15px"
                        }}
                    >
                        <label><StyledDiv className="newInputTextLabel"><span style={{color: "red"}}>*</span> Identify Location Type {generalValidations.externalLocationType !== "" && <StyledDiv style={{color:"red", fontSize: "10px"}}>{generalValidations.externalLocationType}</StyledDiv>}</StyledDiv></label>
                        <Radio.Group 
                            value={formState.externalLocationType}
                            onChange={(e) => {
                                setFormState(prevState => ({ ...prevState, externalLocationType: e.target.value }))
                                if(generalValidations.externalLocationType !== "")
                                    setGeneralValidations(prevState => ({ ...prevState, externalLocationType: "" }));
                            }}
                            style={{
                                marginTop: "10px"
                            }}
                        >
                            
                            <StyledDiv>
                                <Radio value="Well Number" className="newInputText">Well Number</Radio>
                                <Radio value="Field" className="newInputText">Field</Radio>
                                <Radio value="Platform" className="newInputText">Platform</Radio>
                                <Radio value="Rig" className="newInputText">Rig</Radio>
                            </StyledDiv>
                        </Radio.Group>
                    </Col>

                    {formState.externalLocationType !== '' && <Col
                        xl={{span: 12}}
                        lg={{span: 12}}
                        md={{span: 12}}
                        sm={{span: 24}}
                        xs={{span: 24}}
                        style={{
                            paddingRight: "10px",
                            marginBottom: "15px"
                        }}
                    >

                        <label>     
                            <StyledDiv className="newInputTextLabel">
                                <span style={{color: "red"}}>*</span> Identify Location
                                <div className="generalInfoContainer">
                                    <Input placeholder="Enter location"
                                        style={{marginTop: "8px", height: "40px"}} 
                                        onChange={(e) => {
                                            setFormState(prevState => ({ ...prevState, location: e.target.value }))
                                            if(generalValidations.location !== "")
                                                setGeneralValidations(prevState => ({ ...prevState, location: "" }));
                                        }}
                                        value={formState.location}
                                        className={generalValidations.location !== "" ? "newInputText validationInputText" : "newInputText"}
                                    />
                                    {generalValidations.location && 
                                        <span className="validationMessage">{generalValidations.location}</span>
                                    }
                                </div>
                            </StyledDiv>
                        </label>
                    </Col>}

                    <Col
                        xl={{span: 12}}
                        lg={{span: 12}}
                        md={{span: 12}}
                        sm={{span: 24}}
                        xs={{span: 24}}
                        style={{
                            paddingRight: "10px",
                            marginBottom: "15px"
                        }}
                    >

                        <label>     
                            <StyledDiv className="newInputTextLabel">
                                <span style={{color: "red"}}>*</span> Identify Customer
                                <div className="generalInfoContainer">
                                    <Select placeholder="Select other country" style={{width: "100%", marginTop: "8px", height: "40px"}}
                                        onChange={(value) => {
                                            setFormState(prevState => ({ ...prevState, externalCustomer: value }))
                                            if(generalValidations.externalCustomer !== "")
                                                setGeneralValidations(prevState => ({ ...prevState, externalCustomer: "" }));
                                        }}
                                        showSearch
                                        value={formState.externalCustomer}
                                        className={generalValidations.externalCustomer !== "" ? "newInputText validationInputText" : "newInputText"}
                                    >
                                        {getSorted(externalCustomers).map((location, index) => (
                                            <Option key={index} value={location.value} className="newInputText">{location.name}</Option>
                                        ))}
                                    </Select>
                                    {generalValidations.externalCustomer && 
                                        <span className="validationMessage">{generalValidations.externalCustomer}</span>
                                    }
                                </div>
                            </StyledDiv>
                        </label>
                    </Col>
                </>}

                <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >

                    <label><StyledDiv className="newInputTextLabel"><span style={{color: "red"}}>*</span> Observation Type {generalValidations.observationType !== "" && <StyledDiv style={{color:"red", fontSize: "10px"}}>{generalValidations.observationType}</StyledDiv>}</StyledDiv></label>
                    <Radio.Group 
                        value={formState.observationType}
                        onChange={(e) => {
                            setFormState(prevState => ({ ...prevState, observationType: e.target.value }));
                            if(generalValidations.observationType !== "")
                                setGeneralValidations(prevState => ({ ...prevState, observationType: "" }));
                        }}
                        style={{
                            marginTop: "10px"
                        }}
                    >
                        
                        <StyledDiv>
                            <Radio value="Safe Act" className="newInputText">Safe Act</Radio>
                            <Radio value="Unsafe Act" className="newInputText">Unsafe Act</Radio>
                            <Radio value="Unsafe Condition" className="newInputText">Unsafe Condition</Radio>
                        </StyledDiv>
                    </Radio.Group>
                    {formState.observationType !== '' && formState.observationType !== 'Safe Act' && <label><StyledDiv className="newInputTextLabel"
                        style={{
                            marginTop: "8px",
                            fontSize: "10px",
                            fontStyle: "italic",
                        }}
                    >{formState.observationType === 'Unsafe Act' ? conditionDetails.unsafeact : conditionDetails.unsafeconditions }</StyledDiv></label>}
                </Col>

                {(formState.locationType === '' || formState.locationType === 'External') && <Col
                    xl={{span: 12}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 0}}
                    xs={{span: 0}}
                    style={{
                        paddingRight: "10px",
                        marginBottom: "15px"
                    }}
                ></Col>}
            </Row> 

            <Row gutter={[0, 15]} className='InputContainer'>
                <Col
                    xl={{span: 24}}
                    lg={{span: 24}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >

                    <label>     
                        <StyledDiv className="newInputTextLabel">
                            <span style={{color: "red"}}>*</span> Observation Description
                            <div className="generalInfoContainer">
                                <ObservationDescriptionInput 
                                    formState={formState}
                                    setFormState={setFormState}
                                    generalValidations={generalValidations}
                                    setGeneralValidations={setGeneralValidations}
                                />
                            </div>
                        </StyledDiv>
                    </label>
                </Col>
            </Row>
        </>
    )
}
